import styled from 'styled-components';
import { Sizing } from '../../styles/spacing';
type PositionalAlignment =
  | 'start'
  | 'end'
  | 'center'
  | 'space-between'
  | 'space-around'
  | 'space-evenly'
  | 'flex-end'
  | 'flex-start';

type FlexProps = {
  $justifyContent?: PositionalAlignment;
  $flexDirection?: 'row' | 'column';
  $gap?: Sizing;
  $padding?: Sizing;
  $mt?: Sizing;
  $mb?: Sizing;
  $ml?: Sizing;
  $mr?: Sizing;
  $alignItems?: PositionalAlignment;
};
export const Flex = styled.div<FlexProps>`
  display: flex;
  justify-content: ${(p) => p.$justifyContent || 'space-between'};
  flex-direction: ${(p) => p.$flexDirection || 'row'};
  gap: ${(p) => p.$gap || '4px'};
  padding: ${(p) => p.$padding || 'none'};
  align-items: ${(p) => p.$alignItems || 'normal'};

  margin-top: ${(p) => p.$mt || '0'};
  margin-bottom: ${(p) => p.$mb || '0'};
  margin-left: ${(p) => p.$ml || '0'};
  margin-right: ${(p) => p.$mr || '0'};

  & > * {
    flex: 1;
  }
`;
